import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { cookie } from '@ifeng/ui_base';
import errorBoundary from '@ifeng/errorBoundary';
import HBNewsSider from './hbNewsSider';
import HBNews from './hbNews';

class HomeAndBook extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { houseAreaMap, hbNewsSiderData, hbNewsData },
        } = this.props;
        let city = null;
        let houseAreaData = {};

        if (typeof document !== 'undefined') {
            city =
                cookie.get('city') && cookie.get('city') !== '' && cookie.get('city') !== '010'
                    ? cookie.get('city')
                    : null;

            for (const item of houseAreaMap) {
                if (item.city === city) houseAreaData = item;
            }
        }

        return (
            <div className={styles.box}>
                <HBNewsSider content={hbNewsSiderData} listLeft={houseAreaData.listLeft} />
                <HBNews
                    content={hbNewsData}
                    listOne={houseAreaData.listOne}
                    listTwo={houseAreaData.listTwo}
                    isGZ={city === '020'}
                />
            </div>
        );
    }
}

export default errorBoundary(HomeAndBook);
